export default [
  {
    type: "props",
    columns: [
      {
        label: "参数",
        prop: "prop"
      },
      {
        label: "说明",
        prop: "description"
      },
      {
        label: "类型",
        prop: "type"
      },
      {
        label: "可选值",
        prop: "available"
      },
      {
        label: "默认值",
        prop: "default"
      },
      {
        label: "必填",
        prop: "required"
      }
    ]
  },
  {
    type: "events",
    columns: [
      {
        label: "事件名",
        prop: "name"
      },
      {
        label: "说明",
        prop: "description"
      },
      {
        label: "参数",
        prop: "argument"
      }
    ]
  },
  {
    type: "methods",
    columns: [
      {
        label: "方法名",
        prop: "name"
      },
      {
        label: "说明",
        prop: "description"
      },
      {
        label: "参数",
        prop: "argument"
      }
    ]
  },
  {
    type: "slots",
    columns: [
      {
        label: "名称",
        prop: "name"
      },
      {
        label: "说明",
        prop: "description"
      }
    ]
  }
];
